import { render, staticRenderFns } from "./Buenos-Aires.vue?vue&type=template&id=73d66ed0&"
import script from "./Buenos-Aires.vue?vue&type=script&lang=js&"
export * from "./Buenos-Aires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports